import {
  Builderlyags3ldja2y as Builder,
  Builder3vv3qt9kyowg0 as Builder_0,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.e6p_1 = (new (Builder())('input')).l38();
        this.f6p_1 = (new (Builder())('input')).l38();
        this.g6p_1 = (new (Builder())('input')).l38();
        this.h6p_1 = (new (Builder())('input')).l38();
        this.i6p_1 = (new (Builder())('input')).l38();
        this.j6p_1 = (new (Builder())('input')).l38();
        this.k6p_1 = (new (Builder())('input')).l38();
        this.l6p_1 = (new (Builder())('input')).l38();
        this.m6p_1 = (new (Builder())('input')).l38();
        this.n6p_1 = (new (Builder())('input')).l38();
        this.o6p_1 = (new (Builder())('input')).l38();
        this.p6p_1 = (new (Builder())('input')).l38();
        this.q6p_1 = (new (Builder())('input')).l38();
        this.r6p_1 = (new (Builder())('input')).l38();
        this.s6p_1 = (new (Builder())('input')).l38();
        this.t6p_1 = (new (Builder())('input')).l38();
        this.u6p_1 = (new (Builder())('input')).l38();
        this.v6p_1 = (new (Builder())('input')).l38();
        this.w6p_1 = (new (Builder())('input')).l38();
        this.x6p_1 = (new (Builder_0())('Mutation')).l38();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance8d9dd8emdwrf,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
